module.exports = __webpack_public_path__ + "img/Beijing-speed.9b81fc42.png";